module.exports = __webpack_public_path__ + "img/visitor.135114a1.png";